import React from "react";
import PropTypes from 'prop-types';

import { SaveButton, CloseButton } from './index';

const ModalButtons = ({handleSaveClick, handleCloseClick, disabled, ...props }) => {
    return(
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <SaveButton handleSaveClick={handleSaveClick} disabled={disabled} {...props} />
            <CloseButton handleCloseClick={handleCloseClick} {...props} label="Закрыть" />
        </div>
    )
}

ModalButtons.propTypes = {
    handleSaveClick: PropTypes.func,
    handleCloseClick: PropTypes.func
};

export default ModalButtons;